import routes from '../routers'
import VueRouter from 'vue-router'
import Vue from 'vue'
import storage from '../config/local-storage'
import _ from 'lodash'

Vue.use(VueRouter)

const router = new VueRouter({routes})

router.beforeEach((to, from, next) => {


	// caso nao digite a uri
	if(to.path == "/" || to.path == ""){
		next('login')
	}

	// se tiver indo pra login
	if(to.path == "/login"){
		next()
	}

	// se não tiver a base url, vai para login para poder carregar
	if(sessionStorage.getItem(storage.localBaseURL) == null){
		next('login')
	}

	// pega a sessao
	let sessao = null
	if(sessionStorage.getItem(storage.localSession) != null){
		sessao = JSON.parse(sessionStorage.getItem(storage.localSession))
	}

	// se não tiver indo para login
	if(to.path.indexOf('/login') === -1){
		// validar o token
		if(sessao == null){
			next('login')
		} else {
			let rota = _.find(routes[1].children, a => {return a.name == to.name})
			if(!_.isNil(rota)){
				if(rota.privilegio != 0){
					let index = _.findIndex(sessao.privs, o => { return o == rota.privilegio})
					if(index > -1){
						next()
					} else {
						next('inicio')
					}
				}else {
					next()
				}
			}  else {
				next('inicio')
			}
		}
	} else {
		next()
	}
})


export default router



// WEBPACK FOOTER //
// ./src/routers/rules.js